import { render, staticRenderFns } from "./AgcoLogWarehouse.vue?vue&type=template&id=5347b660&scoped=true"
import script from "./AgcoLogWarehouse.vue?vue&type=script&lang=js"
export * from "./AgcoLogWarehouse.vue?vue&type=script&lang=js"
import style0 from "./AgcoLogWarehouse.vue?vue&type=style&index=0&id=5347b660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347b660",
  null
  
)

export default component.exports